import * as React from "react";
import styles from "./Button.css";

interface Props {
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  onClick: () => void;
  className?: string;
}
export const Button = ({
  icon: Icon,
  text,
  onClick,
  className = ""
}: Props) => (
  <div className={`${styles.button} ${className}`} onClick={onClick}>
    {Icon && <Icon className={styles.icon} />}
    <div>{text}</div>
  </div>
);
